import type { FaireProductEntity } from "../../entity_types/product";

export const p_5uq3szvjy8: FaireProductEntity = {
  token: "p_5uq3szvjy8",
  type: "product",
  name: "Extra Spicy Chili Oil",
  brandToken: "b_b86bst3pf8",
  brandName: "Mama Liang's",
  imageUrl:
    "https://cdn.faire.com/fastly/cfa0bfaa56aecc9441b4ee8d4f9b34343fe054449206bb19d64146d8a3385de9.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/aedff66f6cc4a7c4757c7bf3c0df118329e82abbba74da4a193f4dc06c29a712.png",
    "https://cdn.faire.com/fastly/4461fcb1ac551c066f06bf0de90171f06ba2466d7b326c03e5c08c9f3e9691b1.png",
    "https://cdn.faire.com/fastly/2bae6eaef72b24af414f6b6899286aa72c84cb14018c86909bf2a5008bb1966f.jpeg",
  ],
  priceDollars: 7.3,
  description:
    "Slow-caramelized onions, shallots, and ginger are infused with a signature blend of spices and Thai chili peppers for a clean, fragrant heat.\n\nThis versatile condiment is designed to enhance dishes without masking their original flavors. A restaurant-proven staple for over 40 years, it is a high-repeat item that pairs across grocery categories - from fresh produce to pantry staples.",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-06T19:20:11.237Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
